import { IViewSettings } from "./ViewSettings"

export const SHOW_REJECTED_OFFERS_DEFAULT = false

export interface IViewSettingsOffers {
    showRejectedOffers?: boolean
}

export default class ViewSettingsOffers implements IViewSettings {
    showRejectedOffers: boolean = SHOW_REJECTED_OFFERS_DEFAULT

    constructor(data: IViewSettingsOffers) {
        if (typeof data.showRejectedOffers !== "undefined") {
            this.showRejectedOffers = data.showRejectedOffers
        }
    }

    get isDefault() {
        return this.showRejectedOffers === SHOW_REJECTED_OFFERS_DEFAULT
    }
}
